/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Max_Tps_One_Block_NameInputs */



/**
* | output |
* | --- |
* | "Max TPS (1 block)" |
*
* @param {Metric_Max_Tps_One_Block_NameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metric_max_tps_one_block_name = /** @type {((inputs?: Metric_Max_Tps_One_Block_NameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Max_Tps_One_Block_NameInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Max TPS (1 block)")
});